import React from 'react';
export const TrashIcon = () => {
  return (
    <div>
      <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M18.417 7.333H5.583l1.412 12.495a.382.382 0 0 0 .38.339h9.232a.382.382 0 0 0 .38-.339l1.43-12.495z' fill='#E0C1FF' />
        <path
          d='m14.334 10.25-.584 6.417M9.667 10.25l.583 6.417M5.583 7.333h12.834l-1.43 12.495a.382.382 0 0 1-.38.339H7.374a.382.382 0 0 1-.38-.34L5.585 7.334z'
          stroke='var(--theme-primary, #810ea9)'
          stroke-width='1.6'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
        <path
          d='M8.817 4.364v-.362c0-.703.57-1.273 1.273-1.273h3.818c.703 0 1.273.57 1.273 1.273v.362'
          stroke='var(--theme-primary, #810ea9)'
          stroke-width='1.6'
        />
        <path
          d='M5 7.333a.583.583 0 0 1-.583-.583V5.583c0-.322.26-.583.583-.583h14c.322 0 .583.261.583.583V6.75a.583.583 0 0 1-.583.583H5z'
          fill='#E0C1FF'
          stroke='var(--theme-primary, #810ea9)'
          stroke-width='1.6'
          stroke-linejoin='round'
        />
      </svg>
    </div>
  );
};
